// Точка входа: режим снимков (если задан в адресе) — первым, затем экраны, тема и первая загрузка данных.
import './shotClock.ts';
import { shotParams, shotApply } from './shot.ts';
import type { AppState } from '@praktika/core';
import { reloadWhenFree, rpc, type ApiError } from './lib/api.ts';
import { $, esc } from './lib/dom.ts';
import { go, render } from './lib/nav.ts';
import { NAV, S, setS } from './lib/state.ts';
import { applyTheme, initTheme } from './lib/theme.ts';
import './lib/login.ts';
import './screens/today.ts';
import './screens/book.ts';
import './screens/move.ts';
import './screens/sched.ts';
import './screens/clients.ts';
import './screens/group.ts';
import './screens/money.ts';
import './screens/more.ts';
import './screens/calendar.ts';
import './screens/unknown.ts';
import './screens/admin.ts';

let loadedAt = 0, checkedAt = 0;

async function init(): Promise<void> {
  try {
    const s = await rpc<AppState>('state');
    setS(s);
    loadedAt = Date.now();
    applyTheme(s.settings.theme || 'system');
    // вернулись со страницы Google после разрешения на календарь
    if (location.hash === '#go=calendar') { history.replaceState(null, '', location.pathname); NAV.tab = 'more'; go('calendar'); }
    else render();
    if (shotParams) await shotApply(shotParams);
    else if (s.calendar.connected) setTimeout(catchUp, 1500);   // только что подключённый календарь проверяется кнопкой
  } catch (e) {
    if ((e as ApiError).code) return;                   // вход или «нет кабинета» — свой экран уже показан
    $('#app').innerHTML = '<div class="empty">Не удалось загрузить данные: ' + esc((e as Error).message) +
      '<br><br><button class="btn sec" data-retry>Повторить</button></div>';
    $('[data-retry]').onclick = () => location.reload();
  }
}

// Календарь давно не проверяли (фон сервера мог не успеть) — сервер проверит сейчас; пришло новое — перечитать.
function catchUp(): void {
  if (!S?.calendar?.connected || Date.now() - checkedAt < 10 * 60000) return;
  checkedAt = Date.now();
  rpc<{ changed: number; note: string }>('catchUp').then((r) => { if (r.changed) reloadWhenFree(r.note); }, () => {});
}

// Вернулись в приложение через несколько минут — данные могли поменяться (другое устройство, календарь): перечитать.
document.addEventListener('visibilitychange', () => {
  if (document.visibilityState !== 'visible' || !loadedAt) return;
  catchUp();
  if (Date.now() - loadedAt < 5 * 60000) return;
  loadedAt = Date.now();
  reloadWhenFree();
});

initTheme();
void init();
